(function (Drupal,) {
  Drupal.behaviors.ourMission = {
    attach(context) {
      const missionElement = context.querySelector('.our-mission')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            missionElement.classList.add('animate');
          }
        });
      });
      if (missionElement) {
        observer.observe(missionElement);
      }
    },
  };
})(Drupal);
